import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FilterState } from '@immosky/types';

export const selectFilterState = createFeatureSelector<FilterState>('filter');

export const selectIsAnyFilterActive = createSelector(
  selectFilterState,
  (state: FilterState) => {
    return (
      state.category.main.isActive ||
      state.price.isActive ||
      state.roomCount.isActive ||
      state.livingSpace.isActive ||
      state.propertySpace.isActive ||
      state.region.isActive
    );
  }
);

export const selectCountries = createSelector(
  selectFilterState,
  (state: FilterState) => {
    return state.countries;
  }
);
